import { createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { thunk } from "redux-thunk";
import { flightsPostBookingApi } from "@b2bportal/core-flights";
import { middlewares as flightCfarExerciseMiddlewares } from "@b2bportal/core-flights-cfar-exercise";
import { compose, applyMiddleware } from "@reduxjs/toolkit";
import { rootReducer } from "../reducers";
import { rootSaga } from "../sagas";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: (options: {
      trace: boolean;
      traceLimit: number;
    }) => typeof compose;
  }
}
const composeEnhancers =
  (import.meta.env.MODE !== "production" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    })) ||
  compose;

//REDUX SAGA middleware
export const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(
      thunk,
      sagaMiddleware,
      ...flightCfarExerciseMiddlewares,
      flightsPostBookingApi.middleware
    )
  )
);

sagaMiddleware.run(rootSaga);

export type TripsState = ReturnType<typeof store.getState>;
